import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M0 17.9972C0 8.0576 8.0576 0 17.9972 0C27.9367 0 35.9943 8.0576 35.9943 17.9972C35.9943 27.9367 27.9367 35.9943 17.9972 35.9943C8.0576 35.9943 0 27.9367 0 17.9972Z"
      fill="#4CAF50"
    />
    <Path
      d="M23.3289 13.998L15.9982 21.3287L12.666 17.9966"
      stroke="white"
      strokeWidth={1.99929}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
export default SVGComponent;
